// extracted by mini-css-extract-plugin
export default {"clientInfo":"surxiikHUVDatrhlOh58","clientInfoSubheader":"uJVWYNmXyP8nz6Cw1xZK","clientInfoDetails":"_TspPLMecWR2MG8j2Ujp"};